export default __webpack_public_path__ + "static/klaudie-caae2486a87acf50eb518d3e1a479d33.jpg";